/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ServiceTeamSortField {
    Name = 'Name',
    CreatedAtUtc = 'CreatedAtUtc',
    LastUpdatedAtUtc = 'LastUpdatedAtUtc'
}


export function ServiceTeamSortFieldFromJSON(json: any): ServiceTeamSortField {
    return ServiceTeamSortFieldFromJSONTyped(json, false);
}

export function ServiceTeamSortFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTeamSortField {
    return json as ServiceTeamSortField;
}

export function ServiceTeamSortFieldToJSON(value?: ServiceTeamSortField | null): any {
    return value as any;
}

